import React from 'react';

const WEB_DESIGN_LOGOS = [
  '/assets/images/web-design/logos (1).webp',
  '/assets/images/web-design/logos (2).webp',
  '/assets/images/web-design/logos (3).webp',
  '/assets/images/web-design/logos (4).webp'
];

// Repeat to ensure seamless infinite looping marquee
const extendedLogos = [
  ...WEB_DESIGN_LOGOS,
  ...WEB_DESIGN_LOGOS,
  ...WEB_DESIGN_LOGOS,
  ...WEB_DESIGN_LOGOS
];

function AffordableWebDesignSection() {
  const handleDiscussClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('webdesign-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="logo-impact-section">
      <div className="container logo-impact-container">
        {/* Left Column: Content + Auto-Scroll Logos */}
        <div className="logo-impact-left">
          <div className="logo-impact-badge-row">
            <span className="logo-impact-badge">Web Design Services</span>
            <div className="logo-impact-badge-line"></div>
          </div>

          <h2 className="logo-impact-title">
            Affordable & Responsive <span className="text-red">Web Design Services</span>
          </h2>

          <p className="logo-impact-desc">
            Your business is looking for a unique and attractive web design that tells a story of your business and attracts a larger audience. To drive better results, you need a trusted web design company that can blend creativity with functionality to present the best outcomes. <a href="https://expertscommunication.net/" style={{ color: 'var(--primary-color, #c40a0a)', textDecoration: 'none', fontWeight: '600' }}>Experts Communication</a> is here to help, We combine exceptional and eye catching web design with complete functionality to offer the best digital experiences to the users. Represent your brand with professional web design services and let us handle the rest.
          </p>

          <button className="btn-logo-design-action" onClick={handleDiscussClick}>
            Let's Discuss Your Needs
          </button>

          {/* Auto Scroll Logos at Bottom of Left Side */}
          <div className="web-logos-slider-wrapper">
            <div className="web-logos-marquee">
              <div className="web-logos-track">
                {extendedLogos.map((logoSrc, index) => (
                  <div className="web-logo-item" key={index}>
                    <img 
                      src={logoSrc} 
                      alt={`Client Brand Logo ${ (index % WEB_DESIGN_LOGOS.length) + 1 }`} 
                      className="web-logo-img"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Image */}
        <div className="logo-impact-right">
          <div className="logo-impact-img-wrapper">
            <img 
              src="/assets/images/web-design/web-img1.jpg" 
              alt="Affordable & Responsive Web Design Services" 
              className="logo-impact-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AffordableWebDesignSection;
